<template>
  <div>
    <p v-if="phone">
      <phone-icon class="icon-mr" /> <a :href="tel">
        {{ phone }}
      </a>
    </p>
    <p v-if="email">
      <mail-icon class="icon-mr" /> <a :href="'mailto:'+email">
        {{ email }}
      </a>
    </p>
    <p v-if="openingHours">
      <clock-icon class="icon-mr" /> arkisin {{ openingHours.workdays.open }}&ndash;{{ openingHours.workdays.close }}
    </p>
  </div>
</template>

<script>
import {
  PhoneIcon, MailIcon, ClockIcon
} from '@bit/vekenkaluste.veke-ui.icons'

export default {
  name: 'CustomerServiceInfo',
  components: {
    PhoneIcon, MailIcon, ClockIcon
  },
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data () {
    return {
      phone: this.content.fields.phone,
      email: this.content.fields.email,
      openingHours: this.content.fields.openingHours
    }
  },
  computed: {
    tel () {
      return this.phone ? `tel:${this.phone.replace(/\s/g, '')}` : '#'
    }
  }
}
</script>
